module.exports = __webpack_public_path__ + "static/media/12UNCTAD8.1de9499c.jpg";